export const onClearDataSearch = (
  setSearchValue = () => {},
  setFilters = [],
  setShouldClear = () => {},
  setDataFilters = () => {},
  setPageData = () => {}
) => {
  setSearchValue('');
  setFilters([]);
  setShouldClear(true);

  setDataFilters((prevFilters) =>
    prevFilters.map((item) => ({
      ...item,
      value_filter: '',
    }))
  );
  setPageData({
    page: 1,
    size: 10,
  });
};
